/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Stock } from './Stock';
import {
    StockFromJSON,
    StockFromJSONTyped,
    StockToJSON,
} from './Stock';

/**
 * 
 * @export
 * @interface GetStock200ResponseAllOfData
 */
export interface GetStock200ResponseAllOfData {
    /**
     * 
     * @type {Stock}
     * @memberof GetStock200ResponseAllOfData
     */
    stock: Stock;
}

/**
 * Check if a given object implements the GetStock200ResponseAllOfData interface.
 */
export function instanceOfGetStock200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stock" in value;

    return isInstance;
}

export function GetStock200ResponseAllOfDataFromJSON(json: any): GetStock200ResponseAllOfData {
    return GetStock200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetStock200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStock200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stock': StockFromJSON(json['stock']),
    };
}

export function GetStock200ResponseAllOfDataToJSON(value?: GetStock200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stock': StockToJSON(value.stock),
    };
}

